import get_param from '../param'
import {isFunction} from '../typeof'
import * as Cookie from 'tiny-cookie'
import {remove_param} from '../param'
import {autoLogin} from './login'

export function url_without_ticket(url) {
  if (!url) {
    url = window.location.href;
  }
  return remove_param("ticket", url)
}

export function get_h5_ticket(cb) {
  let ticket = null;


  if (!ticket) {
    const hdcn = Cookie.get('HDCN', {domain: "mgtv.com"});
    if (hdcn) {
      ticket = hdcn.substring(0, 20);
    }
  }
  if(!ticket){
    ticket = Cookie.get('ticket', {domain: "mgtv.com"});
  }

  if (!ticket) {
    ticket = get_param('ticket')
  }

  if(!ticket && gact.auto_login){
    autoLogin();
    return
  }
  cb(ticket)
}

function get_app_ticket(cb) {
  if (gact.debug) {
    get_h5_ticket(cb);
    return;
  } else {
    MgtvApi.getUserInfo(function (user_info) {
      if (user_info && user_info.length !== 0) {
        const ticket = (JSON.parse(user_info)).ticket;
        cb(ticket);
      } else {
        cb(null);//没有登录
      }
    })
  }

}


export function get_ticket(cb) {
  if (!isFunction(cb)) {
    console.error("not callback function in get_ticket")
    return;
  }
  if (gact.is_app) {
    get_app_ticket(cb)
  } else {
    get_h5_ticket(cb)
  }
}





// WEBPACK FOOTER //
// ./src/tools/mgtv/ticket.js